<template>
  <div class="flip-card">
    <div class="flip-card-inner" v-bind:class="{ flipped: flipped }">
      <v-card
        :height="config.height"
        class="back cursor"
        @click="flipped = true"
        tile
        :ripple="false"
      >
        <v-container bg fill-height grid-list-md text-center class="pt-0">
          <v-row align="center">
            <v-col>
              <h3
                class="text-h4 font-weight-bold white--text letter-spacing-2 text-uppercase"
              >
                {{ $t('quotes.pickQuote') }}
              </h3>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card :height="config.height" class="front" tile :ripple="false">
        <v-card-title class="card-header">
          <v-row align="center" justify="center" class="pa-1">
            <v-avatar size="100">
              <div class="pa-3 bg-white">
                <v-img width="80" height="80" :src="bulbImg"></v-img>
              </div>
            </v-avatar>
          </v-row>
        </v-card-title>
        <v-card-text class="board-card-content text-center pt-15">
          <v-row>
            <v-col cols="12">
              <span class="font-weight-regular black--text" :class="textClass">
                {{ quote.text[currentUser.lang] }}
              </span>
            </v-col>
            <v-col cols="12" class="mt-2">
              <span
                v-if="quote.author[currentUser.lang]"
                class="text-subtitle-1 font-weight-bold app-green--text font-italic"
              >
                {{ quote.author[currentUser.lang] }}
              </span>
              <span
                v-else
                class="text-subtitle-1 font-weight-bold app-green--text font-italic"
              >
                {{ $t('quotes.unknown') }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-12">
          <v-btn color="app-blue" text block @click="$emit('close')">
            {{ $t('common.continue') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import textSizeHelper from '../../common/text.size.helper';

export default {
  name: 'quote-modal',
  props: {
    quote: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    textClass() {
      return textSizeHelper.getTextClassByLength(
        this.quote.text[this.currentUser.lang].length
      );
    }
  },
  data() {
    return {
      flipped: false,
      bulbImg: require('../../assets/images/bulb.svg')
    };
  }
};
</script>
